export const decode = (value: any) => {
  let content = value;
  let div = document?.createElement('div');
  div.innerHTML = content
  return div?.firstChild?.nodeValue;
};
